import { PaziaSelect } from "components/atoms";
import React from "react";
import { components } from "react-select";
import { ImBooks } from "react-icons/im";
import { PiExamFill, PiCertificateFill, PiVideoFill, PiFilePdfFill } from "react-icons/pi";
import {
  BsCameraVideoFill,
  BsFileText,
  BsFileEarmarkPdf,
  BsFileEarmarkWord,
  BsFileEarmarkZip,
  BsFileEarmarkPlay,
  BsClipboardCheck,
} from "react-icons/bs";
import { CiLink } from "react-icons/ci";
import { FiExternalLink, FiFile, FiDownload, FiFolder } from "react-icons/fi";
import {
  FaBook,
  FaVideo,
  FaFilePdf,
  FaFileWord,
  FaFileExcel,
  FaFilePowerpoint,
  FaGraduationCap,
  FaClipboardList,
  FaDownload,
  FaPlayCircle,
  FaHeadphones,
} from "react-icons/fa";
import {
  MdArticle,
  MdOndemandVideo,
  MdAssignment,
  MdLibraryBooks,
  MdQuiz,
  MdFolder,
  MdAudiotrack,
} from "react-icons/md";
import { HiDocumentText, HiDocumentDownload } from "react-icons/hi";
import { IoDocumentText, IoDocument } from "react-icons/io5";

export const ResourceTabIcons = {
  // Books & Reading Materials
  "im-books": <ImBooks size={24} />,
  "fa-book": <FaBook size={24} />,
  "md-library-books": <MdLibraryBooks size={24} />,

  // Documents
  "bs-file-text": <BsFileText size={24} />,
  "fi-file": <FiFile size={24} />,
  "md-article": <MdArticle size={24} />,
  "hi-document-text": <HiDocumentText size={24} />,
  "io-document-text": <IoDocumentText size={24} />,
  "io-document": <IoDocument size={24} />,

  // PDF Files
  "pi-file-pdf": <PiFilePdfFill size={24} />,
  "fa-file-pdf": <FaFilePdf size={24} />,
  "bs-file-pdf": <BsFileEarmarkPdf size={24} />,

  // Office Documents
  "fa-file-word": <FaFileWord size={24} />,
  "bs-file-word": <BsFileEarmarkWord size={24} />,
  "fa-file-excel": <FaFileExcel size={24} />,
  "fa-file-powerpoint": <FaFilePowerpoint size={24} />,

  // Videos
  "bs-camera-video-fill": <BsCameraVideoFill size={24} />,
  "pi-video": <PiVideoFill size={24} />,
  "fa-video": <FaVideo size={24} />,
  "md-video": <MdOndemandVideo size={24} />,
  "fa-play-circle": <FaPlayCircle size={24} />,
  "bs-file-play": <BsFileEarmarkPlay size={24} />,

  // Audio
  "fa-headphones": <FaHeadphones size={24} />,
  "md-audio": <MdAudiotrack size={24} />,

  // Exams & Tests
  "pi-exam-fill": <PiExamFill size={24} />,
  "md-quiz": <MdQuiz size={24} />,
  "md-assignment": <MdAssignment size={24} />,
  "bs-clipboard-check": <BsClipboardCheck size={24} />,
  "fa-clipboard-list": <FaClipboardList size={24} />,

  // Certificates & Graduation
  "pi-certificate": <PiCertificateFill size={24} />,
  "fa-graduation-cap": <FaGraduationCap size={24} />,

  // Links
  "ci-link": <CiLink size={24} />,
  "fi-external-link": <FiExternalLink size={24} />,

  // Downloads & Archives
  "fi-download": <FiDownload size={24} />,
  "fa-download": <FaDownload size={24} />,
  "hi-document-download": <HiDocumentDownload size={24} />,
  "bs-file-zip": <BsFileEarmarkZip size={24} />,

  // Folders
  "fi-folder": <FiFolder size={24} />,
  "md-folder": <MdFolder size={24} />,
} as const;

export type ResourceTabIcon = keyof typeof ResourceTabIcons;
const options = Object.entries(ResourceTabIcons).map(([value, icon]) => ({ value, label: value, icon }));

export const ClientIconsDropdown = () => {
  return <PaziaSelect required label="Ikona" options={options} components={{ Option }} name="icon" />;
};

const Option = (props: any) => {
  const icon = props.data.icon as React.ReactElement;
  return (
    <div className="text-sm">
      <components.Option {...props} className="!py-1">
        {icon && (
          <div className="flex gap-2">
            <span className="">{icon}</span>
            <span>{props.data.label}</span>
          </div>
        )}
      </components.Option>
    </div>
  );
};
